var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 5.55555V22.2222C25 22.9861 24.7282 23.6403 24.1847 24.1847C23.6412 24.7292 22.987 25.0009 22.2222 25H2.77778C2.01389 25 1.36019 24.7282 0.816667 24.1847C0.273148 23.6412 0.000925926 22.987 0 22.2222V2.77778C0 2.01389 0.272222 1.36019 0.816667 0.816667C1.36111 0.273148 2.01481 0.000925926 2.77778 0H19.4444L25 5.55555ZM12.5 20.8333C13.6574 20.8333 14.6412 20.4282 15.4514 19.6181C16.2616 18.8079 16.6667 17.8241 16.6667 16.6667C16.6667 15.5093 16.2616 14.5255 15.4514 13.7153C14.6412 12.9051 13.6574 12.5 12.5 12.5C11.3426 12.5 10.3588 12.9051 9.54861 13.7153C8.73843 14.5255 8.33333 15.5093 8.33333 16.6667C8.33333 17.8241 8.73843 18.8079 9.54861 19.6181C10.3588 20.4282 11.3426 20.8333 12.5 20.8333ZM4.16667 9.72222H16.6667V4.16667H4.16667V9.72222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.9258eef4c5ea12578c730ff46accf18a.svg";
export { ForwardRef as ReactComponent };